import { render, staticRenderFns } from "./ParcelShopGroup.vue?vue&type=template&id=4ca22b17&"
import script from "./ParcelShopGroup.vue?vue&type=script&lang=ts&"
export * from "./ParcelShopGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports